'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var Card = _interopDefault(require('@material-ui/core/Card'));
var Snackbar = _interopDefault(require('@material-ui/core/Snackbar'));

var RetrievingNote = styled__default(Card)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  padding-top: 35px;\n  background-color: grey;\n  height: 60px;\n  margin-bottom: 10px;\n"], ["\n  padding-top: 35px;\n  background-color: grey;\n  height: 60px;\n  margin-bottom: 10px;\n"])));
var StyledSnackbar = styled__default(Snackbar)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  background-color: none;\n"], ["\n  background-color: none;\n"])));
var MainUL = styled__default.ul(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  display: flex;\n  align-content: flex-end;\n  justify-content: flex-end;\n  flex-direction: column;\n  padding: 8px;\n  overflow-y: auto;\n"], ["\n  display: flex;\n  align-content: flex-end;\n  justify-content: flex-end;\n  flex-direction: column;\n  padding: 8px;\n  overflow-y: auto;\n"])));
var MainDiv = styled__default.div(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  max-height: 90vh;\n  overflow-y: scroll;\n"], ["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  max-height: 90vh;\n  overflow-y: scroll;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.MainDiv = MainDiv;
exports.MainUL = MainUL;
exports.RetrievingNote = RetrievingNote;
exports.StyledSnackbar = StyledSnackbar;
